import React, { useMemo } from 'react';
import './Logo.css';

interface LogoProps {
  width?: number;
  className?: string;
  onClick?: () => void;
}

const Logo: React.FC<LogoProps> = ({ 
  width = 150, 
  className = '', 
  onClick 
}) => {
  const { logoPath, fallbackLogoPath } = useMemo(() => {
    // Force the path to include vendor prefix in production
    // The homepage in package.json is set to "/vendor"
    const basePath = window.location.hostname === 'localhost' && !window.location.port 
      ? '/vendor' 
      : '';

    // Create proper absolute URLs for logo images
    const logoPath = `${basePath}/logo.png`;
    const fallbackLogoPath = `${basePath}/logo192.png`;
    
    console.log('Logo paths:', { 
      logoPath, 
      fallbackLogoPath, 
      hostname: window.location.hostname,
      port: window.location.port,
      pathname: window.location.pathname,
      href: window.location.href
    });
    
    return { logoPath, fallbackLogoPath };
  }, []);

  return (
    <div 
      className={`logo-container ${className}`} 
      onClick={onClick} 
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <img 
        src={logoPath} 
        alt="Skylight Logo" 
        style={{ 
          width: `${width}px`, 
          maxWidth: '100%', 
          height: 'auto' 
        }} 
        onError={(e) => {
          console.error('Logo failed to load:', logoPath);
          const target = e.target as HTMLImageElement;
          
          // Try the fallback logo
          if (target.src.includes('logo.png')) {
            console.log('Trying fallback logo:', fallbackLogoPath);
            target.src = fallbackLogoPath;
          } else if (target.src.includes('logo192.png')) {
            // If fallback also fails, try a direct absolute URL
            console.log('Trying absolute URL for logo');
            target.src = '/vendor/logo.png';
          }
        }}
      />
    </div>
  );
};

export default Logo; 